<template>
    <div class="container maxBoxContainer">
        <div class="brandTitleDiv">
            <p class="brandTitleP textBase roboto700">ya solo queda un último paso</p>
        </div>
        <div class="whiteBack">
            <div class="featherTitle">
                <img src="../../assets/images/iconPluma.png" class="img-fluid icoPluma" alt="EnergyGo">

                <span class="featherText textBase">Firma tu solicitud</span>
            </div>
            <div class="pdfZone">
                <b-row class="roboto400">
                    <b-col cols="12" sm="12" md="9" lg="9" xl="9" class="infoSign">
                        Aquí puedes leer la solicitud y comprobar que tus datos son correctos.
                    </b-col>
                    <b-col class="downloadLink" @click="downloadContract()">
                        <span class="">Descargar</span>
                        <img src="../../assets/images/icodescarga.png" class="icoDownload" alt="downloadLogo">
                    </b-col>
                </b-row>
                <div id="divIFrame" class="divIFrame">
                    <vue-pdf-embed :source="base64PdfToHtml" class="embedContract" id="pdfEmbed"/>
                </div>
                <p class="roboto700 labelSignText">Firma tu solicitud</p>
                <div class="checkbox checkSecureAccess">
                    <input type="checkbox" @click="toogleCheck" id="acepto" value="1">
                    <label for="acepto" class="padLeft10 roboto400">
                        Al marcar la casilla y pulsar “Firmar” reconoces que has visualizado el contenido de la documentación, y que estás conforme con su contenido.
                    </label>
                    <div>
                        <p id="red_dni" v-if="errorLetter" class="errorText roboto400">{{ err }}</p>
                    </div>
                </div>
                <!--Siguiente seccion para boton de firma -->
                <div class="divSign">
                    <button class="buttonNext buttonText btn-block" id="buttonNext" ref="btnNext" @click="singContract" :disabled='disabledButton'>
                        {{ nextContent }}
                        <img src="../../assets/images/loading.svg" class="spinner" id="spinnerNext" v-if="showSpinner" alt="spinnerNext" />
                    </button>
                </div>
                <!--siguiente seccion para cancelacion -->
                <div class="divCancel roboto400">
                    En caso de que algún dato no sea correcto <span class="cancelLink" @click="$bvModal.show('modalCancel'), openPopUp()">cancela el proceso.</span>
                </div>
            </div>
        </div>
        <!-- footerLogo -->
        <footer-main/>
        <!-- modalCancel -->
        <b-modal ref="modalCancel" id="modalCancel" no-close-on-backdrop hide-footer size="lg" title="Cancelación de la firma" @close="closeErrorUp()">
            <div class="d-block">
                <p class="modalText roboto400">¿Seguro que quieres cancelar la firma de tu solicitud?</p>
            </div>
            <div class="divModalBtnCancel">
                <b-button class="mt-3 btnCancel" block @click="cancelContract()">Si, cancelar</b-button>
                <b-button class="mt-3 btnBack" block @click="closeErrorUp()">volver a la firma</b-button>
            </div>
        </b-modal>
        <!-- errors -->
        <div v-if="errorUp" class="boxPop centerCancelDiv popUpShow" ref="popError" id="popUpError">
            <error :numError="numErrorSecure" v-on:closeError="closeErrorUp" />
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);
import constants from '../../assets/environments/constants.json'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
export default {
    components: {
        VuePdfEmbed
    },
    name: 'resumeContract',
    data() {

        return {
            err: 'Debe marcar la casilla para continuar',
            nextContent: 'Firmar',
            disabledButton: false,
            token: '',
            popUp: false,
            errorUp: false,
            numErrorSecure: null,
            viewWidth: false,
            canResend: false,
            refactorEnv: '',
            canSignDisabled: false,
            popUpCancel: false,
            idContract: '',
            idContractCancel: '',
            errorLetter: false,
            base64PdfToHtml:'',
            base64Pdf:'',
            validCheck: false,
            showSpinner: false
        }
    },
    created() {
        if (this.$session.has('setting')) {
            this.refactorEnv = this.$session.get('setting')
        }
        this.token = this.$route.params.token
        if (this.token == undefined && this.$session.has('token')) {
            this.token = this.$session.get('token')
        }


    },
    mounted() {
        if (!this.$session.has('token')) {
          this.$router.push({ name: 'secureAccess' });
        return;
        }
        this.token = this.$session.get('token');
        this.$session.remove('token');

        this.$emit('changeVeil', false, false)
        this.getContractInfo()
        var vm = this
        vm.btnNext = vm.$refs.btnNext
        this.moveView()
    },
    methods: {
        toogleCheck() {
            var vm = this
            vm.errorLetter = false
            if (this.validCheck == true) {
                this.validCheck = false
            }
            else {
                this.validCheck = true
            }
        },
        async getContractInfo() {
            var vm = this
            let urlGet = vm.refactorEnv.getContractInfo
            await this.$http.post(urlGet, {}, {
                headers: {
                    'Authorization': vm.token
                }
            }).then(response => (
                this.contractInfo(response)
            )).catch((error) => {
                this.$emit('changeVeil', true, false)
                this.numErrorSecure = error.status
                this.errorUp = true
                this.moveView()
            })
        },
        contractInfo(response) {
            this.base64Pdf = response.data.pdf
            this.idContract = response.data.id_mm
            var name_file = 'contrato_'+this.idContract+'.pdf'
            if(this.isIOSFunc()){this.base64PdfToHtml = 'data:application/octet-stream;charset=utf-16le;name='+name_file+';base64,' + this.base64Pdf}
            else{this.base64PdfToHtml = 'data:application/pdf;base64,' + this.base64Pdf;}
            this.$emit('changeVeil', false,false)
        },

        downloadContract() {
            const link = document.createElement('a');
            var name_file = 'contrato_'+this.idContract+'.pdf'
            if(this.isIOSFunc()){
                link.href = 'data:application/octet-stream;charset=utf-16le;name='+name_file+';base64,' + this.base64Pdf;
                link.setAttribute('id', 'link_contract');
                link.title='enlace'
            }else{ link.href = 'data:application/pdf;base64,' + this.base64Pdf; }
            link.setAttribute('download', name_file);
            document.body.appendChild(link);
            link.click();
        },
        async singContract() {
            var vm = this
            vm.disabledButton = true
            vm.nextContent = ""
            vm.showSpinner = true
            vm.btnNext.classList.add('buttonDisabled')
            vm.btnNext.classList.remove('buttonNext')
            if (!vm.validCheck){
                this.errorLetter = true
                this.err = 'Debe marcar la casilla para continuar'
            }else{
              let url = this.refactorEnv.accept
              await this.$http.post(url,{}, {
                  headers: {
                      'Authorization': vm.token
                  }
              }).then(response => (
                  this.goFinal(response)
              )).catch((error) => {
                  this.$emit('changeVeil', true, false)
                  this.numErrorSecure = error.status
                  this.errorUp = true
                  this.moveView()
              })
            }
            vm.showSpinner = false
            vm.disabledButton = false
            vm.nextContent = 'Firmar'
            vm.btnNext.classList.add('buttonNext')
            vm.btnNext.classList.remove('buttonDisabled')
        },
        closePopUpCancel() {
            this.moveView()
            this.$emit('changeVeil', false, false)
            this.popUpCancel = false
        },
        closeErrorUp() {
            this.$refs['modalCancel'].hide()
            this.errorUp = false
            this.$emit('changeVeil', false, false)
        },
        moveView() {
            window.scrollTo(constants.lengthZero, constants.lengthZero);
        },
        async cancelContract(){
            var vm = this
            this.$refs['modalCancel'].hide()
            this.$emit('changeVeil', true, true)
            let url = this.refactorEnv.cancel
            await this.$http.post(url, {}, {headers: {'Authorization': vm.token}
            }).then(response => (
                this.goToCancelScreen(response)
            )).catch((error) => {
                this.$emit('changeVeil', true, false)
                this.numErrorSecure = error.status
                this.errorUp = true
                this.moveView()
            })
        },
        goToCancelScreen(response) {
            this.$emit('changeVeil', false, false)
            var urlToGo =  response.body.url
            window.location.href = urlToGo
        },
        goFinal(response) {
            var urlToGo =  response.body.url
            window.location.href = urlToGo
        },
        isEmpty(value) {
            var ret = (value === undefined || value == null || value.length <= constants.lengthZero) ? true : false;
            return ret
        },
        isIOSFunc(){
            var isIOS = false
            if(
                (navigator.userAgent.match('Macintosh')) ||
                (navigator.userAgent.match('iPhone')) ||
                (navigator.userAgent.match('iPod')) ||
                (navigator.userAgent.match('iPad'))
            ){isIOS = true}
            return isIOS
        },
        openPopUp() {
            this.$emit('changeVeil', true, false)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/resumeContract/resumeContract.vue